import { useContext, useMemo } from 'react';
import { usePermissions } from '@components/contexts/PermissionsProvider';
import { UserContext } from '@components/contexts/UserProvider';

export const useHasPermission = (keys: string | string[], mode: 'any' | 'all' = 'any'): boolean => {
	const { isOe } = useContext(UserContext);
	const permissions = usePermissions();

	const hasPermission = useMemo(() => {
		const names = Array.isArray(keys) ? keys : [keys];

        if (mode === 'all') {
            return names.every((name) => permissions.some((p) => p.name === name));
        } else {
            return names.some((name) => permissions.some((p) => p.name === name));
        }
    }, [permissions, keys, mode]);

	//Bypassa se isOe è true
    return isOe ? true : hasPermission;
};

//opzionale per ottenere i dettagli del permesso
export const usePermissionDetails = (key: string) => {
	const permissions = usePermissions();
	return permissions.find((p) => p.name === key);
};
